import { Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';

import { AuthService } from './core/services/auth.service';

@Component({
	selector: 'dix-root',
	templateUrl: './app.component.html',
	standalone: false,
})
export class AppComponent {
	private readonly auth = inject(AuthService);
	private readonly matIconRegistry = inject(MatIconRegistry);

	constructor() {
		this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined', 'mat-ligature-font');
		this.auth.init();
	}
}
